const FileDownload = (
    <>
        <clipPath id="a">
            <path d="m0 0h18v18h-18z" />
        </clipPath>
        <g clipPath="url(#a)">
            <path d="m16.72 14.22-1.22 1.22v-3.189c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.189l-1.22-1.22c-.293-.293-.768-.293-1.061 0s-.293.768 0 1.061l2.5 2.5c.146.146.338.22.53.22s.384-.073.53-.22l2.5-2.5c.293-.293.293-.768 0-1.061s-.768-.293-1.061 0z" />
            <path d="m10.659 16.341c-.877-.877-.877-2.305 0-3.182.425-.425.99-.659 1.591-.659.084 0 .168.004.25.014v-.264c0-1.241 1.01-2.25 2.25-2.25.462 0 .892.141 1.25.381v-3.717c0-.467-.182-.907-.513-1.237l-3.914-3.914c-.331-.331-.77-.513-1.237-.513h-5.586c-1.517 0-2.75 1.233-2.75 2.75v10.5c0 1.517 1.233 2.75 2.75 2.75h6.568zm-.159-13.762c.009-.004.004-.001.013-.005l3.922 3.921s-.001.003-.002.005h-2.932c-.55 0-1-.45-1-1v-2.921zm-4.75 3.421h2c.414 0 .75.336.75.75s-.336.75-.75.75h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm-.75 3.75c0-.414.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-4.5c-.414 0-.75-.336-.75-.75z" />
        </g>
    </>
);

export { FileDownload };
